const actionTypes = {
  SET_NSW_ITEMS: 'SET_NSW_ITEMS',
  SELECT_NSW_ITEM: 'SELECT_NSW_ITEM',
  SET_NSW_LOADING: 'SET_NSW_LOADING',
  SET_NSW_SIDEBAR_OPEN: 'SET_NSW_SIDEBAR_OPEN',
  MARK_NSW_APPLIED: 'MARK_NSW_APPLIED',
  MARK_ALL_NSW_APPLIED: 'MARK_ALL_NSW_APPLIED',
  UPDATE_PRONUNCIATION: 'UPDATE_PRONUNCIATION',
  SYNC_NSW_ITEMS_WITH_ENTITIES: 'SYNC_NSW_ITEMS_WITH_ENTITIES',
  RESET_NSW: 'RESET_NSW',
};

const setNswItems = (items) => ({
  type: actionTypes.SET_NSW_ITEMS,
  payload: items,
});
const selectNswItem = (index) => ({
  type: actionTypes.SELECT_NSW_ITEM,
  payload: index,
});
const setNswLoading = (isLoading) => ({
  type: actionTypes.SET_NSW_LOADING,
  payload: isLoading,
});
const setNswSidebarOpen = (isOpen) => ({
  type: actionTypes.SET_NSW_SIDEBAR_OPEN,
  payload: isOpen,
});
const markNswApplied = (index) => ({
  type: actionTypes.MARK_NSW_APPLIED,
  payload: index,
});
const markAllNswApplied = (word, pronunciation) => ({
  type: actionTypes.MARK_ALL_NSW_APPLIED,
  payload: { word, pronunciation },
});
const updatePronunciation = (index, pronunciation) => ({
  type: actionTypes.UPDATE_PRONUNCIATION,
  payload: { index, pronunciation },
});
const syncNswItemsWithEntities = (survivingWords) => ({
  type: actionTypes.SYNC_NSW_ITEMS_WITH_ENTITIES,
  payload: survivingWords,
});
const resetNsw = () => ({ type: actionTypes.RESET_NSW });

export {
  actionTypes,
  setNswItems,
  selectNswItem,
  setNswLoading,
  setNswSidebarOpen,
  markNswApplied,
  markAllNswApplied,
  updatePronunciation,
  syncNswItemsWithEntities,
  resetNsw,
};
